import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from '@/lib/auth';
import { AppShell } from '@/components/AppShell';
import { Toaster } from '@/components/ui/sonner';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import Repartidores from '@/pages/Repartidores';
import Clientes from '@/pages/Clientes';
import Grupos from '@/pages/Grupos';
import Almacenes from '@/pages/Almacenes';
import Vales from '@/pages/Vales';
import Revision from '@/pages/Revision';
import Garantia from '@/pages/Garantia';
import Tarimas from '@/pages/Tarimas';
import Embarques from '@/pages/Embarques';
import Inventario from '@/pages/Inventario';
import Bitacora from '@/pages/Bitacora';
import Usuarios from '@/pages/Usuarios';
import Ajustes from '@/pages/Ajustes';
import Reportes from '@/pages/Reportes';
import ConteoFisico from '@/pages/ConteoFisico';
import '@/App.css';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center h-screen bg-[#F7F9FB]"><p>Cargando...</p></div>;
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell>{children}</AppShell>;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center h-screen bg-[#F7F9FB]"><p>Cargando...</p></div>;
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/repartidores" element={<ProtectedRoute><Repartidores /></ProtectedRoute>} />
      <Route path="/clientes" element={<ProtectedRoute><Clientes /></ProtectedRoute>} />
      <Route path="/grupos" element={<ProtectedRoute><Grupos /></ProtectedRoute>} />
      <Route path="/almacenes" element={<ProtectedRoute><Almacenes /></ProtectedRoute>} />
      <Route path="/vales" element={<ProtectedRoute><Vales /></ProtectedRoute>} />
      <Route path="/revision" element={<ProtectedRoute><Revision /></ProtectedRoute>} />
      <Route path="/garantia" element={<ProtectedRoute><Garantia /></ProtectedRoute>} />
      <Route path="/tarimas" element={<ProtectedRoute><Tarimas /></ProtectedRoute>} />
      <Route path="/embarques" element={<ProtectedRoute><Embarques /></ProtectedRoute>} />
      <Route path="/inventario" element={<ProtectedRoute><Inventario /></ProtectedRoute>} />
      <Route path="/bitacora" element={<ProtectedRoute><Bitacora /></ProtectedRoute>} />
      <Route path="/ajustes" element={<ProtectedRoute><Ajustes /></ProtectedRoute>} />
      <Route path="/reportes" element={<ProtectedRoute><Reportes /></ProtectedRoute>} />
      <Route path="/conteo" element={<ProtectedRoute><ConteoFisico /></ProtectedRoute>} />
      <Route path="/usuarios" element={<ProtectedRoute><Usuarios /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
